export default function () {
  const el = document.querySelector('.header-podcast--wrapper');

  if (!el) return;
}
